import * as newAlbums from '../assets/img/newalbums';

export const ALL_EBADS = [
    '25x40',
    '25x50',
    '25x60',
    '25x70',
    '30x50',
    '30x60',
    '30x65',
    '30x70',
    '30x80',
];

export const albumEbads = {
    SA_101: {
        name: 'SA-101',
        image: newAlbums.sa_101,
        ebads: ['25x60', '25x70', '30x60', '30x80', '30x65']
    },
    SA_102: {
        name: 'SA-102',
        image: newAlbums.sa_102,
        ebads: ['25x40', '25x50', '25x60', '25x70', '30x60', '30x65', '30x50', '30x70', '30x80']
    },
    SA_103: {
        name: 'SA-103',
        image: newAlbums.sa_103,
        ebads: ['25x60', '25x70', '30x60', '30x65', '30x70', '30x80']
    },
    SA_104: {
        name: 'SA-104',
        image: newAlbums.sa_104,
        ebads: ['25x60', '25x70', '30x60', '30x65', '30x70', '30x80']
    },
    SA_105: {
        name: 'SA-105',
        image: newAlbums.sa_105,
        ebads: ['25x60', '25x70', '30x60', '30x65', '30x70', '30x80']
    },
    SA_106: {
        name: 'SA-106',
        image: newAlbums.sa_106,
        ebads: ['25x60', '25x70', '30x60', '30x65', '30x70', '30x80']
    },
    SA_107: {
        name: 'SA-107',
        image: newAlbums.sa_107,
        ebads: ['25x60', '25x70', '30x60', '30x65', '30x70', '30x80']
    },
    SA_108: {
        name: 'SA-108',
        image: newAlbums.sa_108,
        ebads: ALL_EBADS,
        all: true
    },
    SA_109: {
        name: 'SA-109',
        image: newAlbums.sa_109,
        ebads: ['25x60', '25x70', '30x60', '30x65', '30x70', '30x80']
    },
    SA_110: {
        name: 'SA-110',
        image: newAlbums.sa_110,
        ebads: ['25x60', '25x70', '25x50', '30x60', '30x65', '30x70', '30x80']
    },
    SA_111: {
        name: 'SA-111',
        image: newAlbums.sa_111,
        ebads: ALL_EBADS,
        all: true
    },
    SA_112: {
        name: 'SA-112',
        image: newAlbums.sa_112,
        ebads: ['25x60', '25x70', '30x60', '30x65', '30x70', '30x80']
    },
    SA_113: {
        name: 'SA-113',
        image: newAlbums.sa_113,
        ebads: ['25x60', '25x70', '30x60', '30x65', '30x70', '30x80']
    },
    SA_114: {
        name: 'SA-114',
        image: newAlbums.sa_114,
        ebads: ALL_EBADS,
        all: true
    },
    SA_115: {
        name: 'SA-115',
        image: newAlbums.sa_115,
        ebads: ['25x60', '25x50', '25x70', '30x50', '30x60', '30x80', '30x70', '30x80']
    },
    SA_116: {
        name: 'SA-116',
        image: newAlbums.sa_116,
        ebads: ['25x60', '25x70', '30x60', '30x65', '30x70', '30x80']
    },
    SA_117: {
        name: 'SA-117',
        image: newAlbums.sa_117,
        ebads: ALL_EBADS,
        all: true
    },
    SA_118: {
        name: 'SA-118',
        image: newAlbums.sa_118,
        ebads: ALL_EBADS,
        all: true
    },
    SA_119: {
        name: 'SA-119',
        image: newAlbums.sa_119,
        ebads: ['25x70', '30x60', '30x65', '30x70', '30x80']
    },
    SA_120: {
        name: 'SA-120',
        image: newAlbums.sa_120,
        ebads: ['25x60', '25x70', '30x60', '30x65', '30x70', '30x80']
    },
    SA_121: {
        name: 'SA-121',
        image: newAlbums.sa_121,
        ebads: ['25x60', '25x70', '30x60', '30x65', '30x70', '30x80']
    },
    SA_122: {
        name: 'SA-122',
        image: newAlbums.sa_122,
        ebads: ['25x60', '25x70', '30x60', '30x65', '30x70', '30x80']
    },
    SA_123: {
        name: 'SA-123',
        image: newAlbums.sa_123,
        ebads: ['25x60', '25x70', '30x60', '30x65', '30x70', '30x80']
    },
    SA_124: {
        name: 'SA-124',
        image: newAlbums.sa_124,
        ebads: ['25x60', '25x70', '30x60', '30x65', '30x70', '30x80']
    },
    SA_125: {
        name: 'SA-125',
        image: newAlbums.sa_125,
        ebads: ['25x50', '25x60', '25x70', '30x60', '30x65', '30x70', '30x80']
    },
    SA_126: {
        name: 'SA-126',
        image: newAlbums.sa_126,
        ebads: ['25x60', '25x70', '30x60', '30x65', '30x70', '30x80']
    },
    SA_127: {
        name: 'SA-127',
        image: newAlbums.sa_127,
        ebads: ['25x40', '25x50', '25x60', '25x70', '30x60', '30x65', '30x70', '30x80']
    },
    SA_128: {
        name: 'SA-128',
        image: newAlbums.sa_128,
        ebads: ['25x60', '25x70', '30x60', '30x65', '30x70', '30x80']
    },
    SA_129: {
        name: 'SA-129',
        image: newAlbums.sa_129,
        ebads: ['25x60', '25x70', '30x60', '30x70', '30x80']
    },
    SA_130: {
        name: 'SA-130',
        image: newAlbums.sa_130,
        ebads: ['25x60', '25x70', '30x50', '30x70', '30x80']
    },
};

export function getCoverImageByModelName(coverModelName) {
    if (!coverModelName || coverModelName === 'null') {
        return null;
    }

    const normalized = String(coverModelName).trim().toUpperCase();
    const album = Object.values(albumEbads).find((item) => item.name.toUpperCase() === normalized);

    return album ? album.image : null;
}

export function getAbsoluteAssetUrl(assetUrl) {
    if (!assetUrl) {
        return null;
    }

    if (/^https?:\/\//i.test(assetUrl)) {
        return assetUrl;
    }

    const path = assetUrl.startsWith('/') ? assetUrl : `/${assetUrl}`;
    return `${window.location.origin}${path}`;
}